var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{staticClass:"background-white",attrs:{"padless":""}},[_c('v-sheet',{staticClass:"mx-auto my-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }